// Auto-généré par scripts/generate-version.js — NE PAS MODIFIER
const buildInfo = {
  version: '1.0.1',
  commitHash: 'fc42b38',
  branch: 'develop',
  context: 'branch-deploy',
  buildDate: '2026-09-09',
};
export default buildInfo;
